import { useCallback, useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import { useAuth } from '../context/AuthContext';

export function usePortfolio() {
  const { user } = useAuth();
  const [holdings, setHoldings] = useState([]);
  const [loading, setLoading] = useState(true);

  const load = useCallback(async () => {
    if (!user) {
      setHoldings([]);
      setLoading(false);
      return;
    }
    setLoading(true);
    const { data, error } = await supabase
      .from('portfolio_holdings')
      .select('*')
      .eq('user_id', user.id)
      .order('created_at', { ascending: false });
    if (error) {
      console.error(error);
      setHoldings([]);
    } else {
      setHoldings(data ?? []);
    }
    setLoading(false);
  }, [user]);

  useEffect(() => {
    load();
  }, [load]);

  const addHolding = useCallback(
    async ({ symbol, shares, price }) => {
      if (!user) return;
      const { error } = await supabase.from('portfolio_holdings').insert({
        user_id: user.id,
        ticker: symbol.toUpperCase(),
        shares: Number(shares),
        purchase_price: Number(price),
      });
      if (error) {
        console.error(error);
        return;
      }
      await load();
    },
    [user, load]
  );

  const removeHolding = useCallback(
    async (id) => {
      if (!user) return;
      const { error } = await supabase
        .from('portfolio_holdings')
        .delete()
        .eq('id', id)
        .eq('user_id', user.id);
      if (error) {
        console.error(error);
        return;
      }
      await load();
    },
    [user, load]
  );

  return {
    holdings,
    loading,
    addHolding,
    removeHolding,
    reload: load,
  };
}
